import { memo } from 'react';
import styled from '@emotion/styled';

import { ActionButtonLink } from '../ActionButton';
import { Item, ItemDescription } from './BusinessItem';
import { H3 } from './HeadlineItem';

import type { Wws_LivestreamItem } from '../../types/graphql';

const Button = styled(ActionButtonLink)`
  width: fit-content;
  margin: 0 auto;

  .verticalLayout.homePage & {
    margin-left: 0;
  }
`;

export interface LivestreamItemProps {
  item: Wws_LivestreamItem;
  className?: string | undefined;
}

function LivestreamItem({ item, className }: LivestreamItemProps) {
  const { id, title, description, buttonUrl, buttonText } = item;

  return (
    <Item className={className} data-testid={`livestream-item-${id}`}>
      <H3>{title}</H3>

      <ItemDescription>{description}</ItemDescription>

      <Button
        target="_blank"
        rel="nofollow ugc noopener noreferrer"
        href={buttonUrl || ''}
      >
        {buttonText}
      </Button>
    </Item>
  );
}

export default memo(LivestreamItem);
